/** Fiche client → onglet Portail. */
import { ClientPortalActions } from "./ClientPortalActions";
import type { Client } from "./types";

export function ClientPortalPanel({ client }: { client: Client }) {
  return <ClientPortalActions client={client} />;
}
